import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-truck-report',
	templateUrl: './truck-report.component.html',
	styleUrls: ['./truck-report.component.css']
})
export class TruckReportComponent implements OnChanges{

	@Input() selectedTruckCriteriaPrint: any;
	@Input() data: any;
	@Input() device: any;
	@Input() currentSite: any;
	
	selectedPeriodFormatted: string = '';
	selectedPeriod: string = '';
	selectedDays: string = '';

	ngOnChanges(changes: SimpleChanges): void {
		if(changes['selectedTruckCriteriaPrint'] || changes['data']) {
			this.selectedPeriod = this.selectedTruckCriteriaPrint.period;
			this.selectedDays = this.selectedTruckCriteriaPrint.days;
		}
	}
}
